export default "__VITE_PUBLIC_ASSET__42d922ab__"